<script lang="ts" setup>
import {onMounted} from "vue";

defineOptions({ name: "DemoAdmin" });

onMounted(() => {
  document.title = "Admin/Demo";
});
</script>

<template>
  <div>
    <h2>Demo Area</h2>
    <p>This area is available for testing new components.</p>
  </div>
</template>
